import { useState } from 'react';
import QuotePanel from './QuotePanel';

function ResaleQuotePanel({
  title,
  hint,
  quoteKind,
  report,
  booking,
  defaultOpen = false,
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className="resale-quote-section">
      <button
        type="button"
        className="resale-quote-toggle"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="material-symbols-outlined" aria-hidden="true">
          {quoteKind === 'inspection' ? 'fact_check' : 'build'}
        </span>
        <span className="resale-quote-toggle-copy">
          <strong>{title}</strong>
          <small>{hint}</small>
        </span>
        <span className="material-symbols-outlined resale-quote-chevron" aria-hidden="true">
          {open ? 'expand_less' : 'expand_more'}
        </span>
      </button>

      {open ? (
        <QuotePanel
          booking={booking}
          variant="resale"
          quoteKind={quoteKind}
          resaleReport={report}
        />
      ) : null}
    </section>
  );
}

export default function ResaleQuoteSection({ report, booking }) {
  const repairCount = (report?.immediate_repairs || []).filter((row) => row?.title?.trim()).length;

  if (!booking?.id) {
    return (
      <section className="resale-quotes-wrap">
        <h3 className="resale-quotes-title">Quotations for seller</h3>
        <p className="muted resale-quote-walkin">
          This walk-in report has no linked app booking. Share repair estimates on the
          inspection PDF or buyer report instead.
        </p>
      </section>
    );
  }

  return (
    <section className="resale-quotes-wrap">
      <h3 className="resale-quotes-title">Quotations for seller</h3>
      <p className="resale-quotes-lede">
        Optional — send one or both quotations to the seller&apos;s app booking.
      </p>

      <ResaleQuotePanel
        title="Pre-sale inspection quotation"
        hint="Bill for the certified inspection service. Price is pulled from your service catalog."
        quoteKind="inspection"
        report={report}
        booking={booking}
        defaultOpen
      />

      <ResaleQuotePanel
        title="Repair quotation"
        hint={
          repairCount > 0
            ? `${repairCount} repair line${repairCount === 1 ? '' : 's'} from the inspection can be imported.`
            : 'Quote recommended repairs found during the inspection.'
        }
        quoteKind="repair"
        report={report}
        booking={booking}
        defaultOpen={repairCount > 0}
      />
    </section>
  );
}
